import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Modal
} 
from '../../../noser-hris-component';

class CreateRateCard extends Component {
    constructor(props) {
        super(props)
        this.ref = React.createRef();
        this.state = {
            userinfo    :   JSON.parse(sessionStorage.getItem("userData")),
            isloading   :   false,
            isshow      :   false,
            alerttype   :   "",
            message     :   "",
            color       :   "",
            fade        :   true,
            disableBtn  :   true,

            stdRate     :   [],
            code        :   '',
            name        :   '',
            isAddBasic  :   false,
            percentage  :   ''
        }
    }
    componentDidMount(){
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.props.onRefModal(this)
    }
    componentWillUnmount() {
        this.props.onRefModal(undefined)
    }
    initialize=(e)=>{
        this.setState({
            userinfo    :   JSON.parse(sessionStorage.getItem("userData")),
            isloading   :   false,
            isshow      :   false,
            alerttype   :   "",
            message     :   "",
            color       :   "",
            fade        :   true,
            disableBtn  :   true,

            code        :   '',
            name        :   '',
            isAddBasic  :   false,
            percentage  :   ''
        })
    }
    handleSubmit = async (e) =>{
        this.setState({isloading:true})

        if(this.state.name==""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter rate name.",
                fade        :   true
            })
            return 
        }
        if(this.state.code==""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter rate code.",
                fade        :   true
            })
            return 
        }
        if(this.state.percentage==""){
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter rate perentage.",
                fade        :   true
            })
            return 
        }

        
        const param = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "Code":this.state.code,
            "Name":this.state.name,
            "Percentage":this.state.percentage,
            "IsAddBasic":this.state.isAddBasic ? "1" : "0",
        }
        
        await axios
            .post(
                AppConfiguration.Setting().noserapiendpoint + "Maintenance/AddRateElement",  param
            )
            .then(res => {
                const data = res.data;
                this.setState({
                    isloading   :   false,
                    alerttype   :   res.data.status=="1" ? "Success!" : "!Error",
                    isshow      :   true,
                    color       :   res.data.status=="1" ? "success" : "danger",
                    message     :   data.message,
                    fade        :   true,
                    name        :   ''
                });
            })
            .catch(error=>{
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade        :   true,
                    name        :   ''
                })
            })
    }
    handleModalClose = () => {
        this.props.onHide();            
    }
    handleChanged = (e) =>{
        this.setState({[e.target.name]: e.target.value,alerttype:"",isshow:false,color:"",message:"",fade:false})
    }
    handleCheckboxChanged = (e) =>{
        this.setState({[e.target.name]: e.target.checked})
    }
    IsDecimal(evt)
    {
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode( key );
        var regex = /^\d*\.?(?:\d{1,2})?$/;
        if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
        }
    }
    render() {
    return(
        
            <Modal
                {...this.props}
                return
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton className="card-header">
                    <Modal.Title id="contained-modal-title-vcenter">
                        CREATE RATE ELEMENT
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                            <div className={this.state.color}></div> 
                            {this.state.message}
                        </Alert>
                        <Form.Row>
                            <Form.Group as={Col} sm={12} >
                                <Form.Control 
                                    name='code'
                                    type="text" 
                                    placeholder="Enter rate code" 
                                    onChange={this.handleChanged} 
                                    autoComplete="off" 
                                    value={this.state.code}
                                    
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                        <Form.Group as={Col} sm={12} >
                                <Form.Control 
                                    name='name'
                                    type="text" 
                                    placeholder="Enter rate name" 
                                    onChange={this.handleChanged} 
                                    autoComplete="off" 
                                    value={this.state.name}
                                    
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} sm={4}>
                                <Form.Check type="checkbox"
                                    label="Add to Basic"
                                    name="IsAddBasic"
                                    checked={this.state.isAddBasic}
                                    onChange={this.handleCheckboxChanged}
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={8}>
                                <Form.Control type="numeric"
                                    name="percentage"
                                    placeholder="%"
                                    autoComplete="off" 
                                    onChange={this.handleChanged}
                                    value={this.state.percentage}
                                    onKeyPress={this.IsDecimal.bind(this)}
                                    maxLength="4"
                                    />
                            </Form.Group>
                        </Form.Row>
                        {/* <Form.Row>
                            <Form.Group as={Col} sm={4}>
                                <Form.Check type="checkbox" 
                                        label="Override Standard" 
                                        name="override"
                                        onChange={this.handleChangeOverride}
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={8}>
                                <Typeahead
                                    labelKey='name'
                                    id="basic-example"
                                    onChange={ this.handleChangeElement}
                                    options={this.state.stdRate}
                                    placeholder="Select Standard Element"
                                    disabled={ this.state.Override}
                                /> 
                            </Form.Group>
                        </Form.Row> */}
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar >
                        <Button variant="success" className="ml-auto noser-button-mr1" onClick = { this.handleSubmit }>Save</Button>
                        <Button variant="danger" className="noser-button-mr15" onClick={this.props.onHide}>Close</Button>
                    </ButtonToolbar>
                </Modal.Footer>
                <NoserLoading show={this.state.isloading} />
        </Modal>
        );
    }
}
export default CreateRateCard